import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function (value, format) {
  return moment(value).format(format)
})

Vue.filter('formatUTCDate', function (value, format) {
  return moment.utc(value).format(format)
})



// WEBPACK FOOTER //
// ./src/filters/moment.js